import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();

  // Cierra el menú móvil cuando cambia la ruta
  useEffect(() => {
    setIsOpen(false);
    setServicesOpen(false);
  }, [location.pathname]);

  const menuItems = [
    { title: 'Inicio', path: '/' },
    {
      title: 'Servicios',
      path: '/servicios',
      submenu: [
        { title: 'Inteligencia Artificial', path: '/servicios/ia' },
        { title: 'Mantenimiento Informático', path: '/servicios/mantenimiento' },
        { title: 'Ciberseguridad', path: '/servicios/ciberseguridad' },
        { title: 'Soporte Técnico', path: '/servicios/soporte' },
        { title: 'Cloud y Hosting', path: '/servicios/cloud' },
        { title: 'Hardware', path: '/servicios/hardware' },
      ],
    },
    { title: 'Sobre Nosotros', path: '/sobre-nosotros' },
    { title: 'Clientes', path: '/clientes' },
    { title: 'Contacto', path: '/contacto' },
  ];

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <img src="/logo.svg" alt="VGBComputers Logo" className="h-10 w-10 mr-2" />
              <span className="text-2xl font-bold text-blue-600">VGBComputers</span>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center">
            {menuItems.map((item) => (
              <div key={item.title} className="relative ml-8">
                {item.submenu ? (
                  <div className="group">
                    <Link to={item.path} className="text-gray-700 hover:text-blue-600 flex items-center">
                      <span>{item.title}</span>
                      <SafeIcon icon={FiIcons.FiChevronDown} className="ml-1" />
                    </Link>
                    <div className="absolute top-full left-0 w-64 bg-white shadow-lg rounded-md py-2 hidden group-hover:block z-50">
                      {item.submenu.map((subItem) => (
                        <Link
                          key={subItem.title}
                          to={subItem.path}
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
                        >
                          {subItem.title}
                        </Link>
                      ))}
                    </div>
                  </div>
                ) : (
                  <Link to={item.path} className="text-gray-700 hover:text-blue-600">
                    {item.title}
                  </Link>
                )}
              </div>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700 hover:text-blue-600"
            >
              <SafeIcon icon={isOpen ? FiIcons.FiX : FiIcons.FiMenu} className="h-6 w-6" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden">
          {menuItems.map((item) => (
            <div key={item.title}>
              {item.submenu ? (
                <>
                  <div
                    className="px-4 py-2 text-gray-700"
                    onClick={() => setServicesOpen(!servicesOpen)}
                  >
                    <span>{item.title}</span>
                    <SafeIcon
                      icon={servicesOpen ? FiIcons.FiChevronUp : FiIcons.FiChevronDown}
                      className="ml-2 inline"
                    />
                  </div>
                  {servicesOpen && (
                    <div className="bg-gray-50">
                      {item.submenu.map((subItem) => (
                        <Link
                          key={subItem.title}
                          to={subItem.path}
                          className="block px-8 py-2 text-sm text-gray-700"
                        >
                          {subItem.title}
                        </Link>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <Link
                  to={item.path}
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-50"
                >
                  {item.title}
                </Link>
              )}
            </div>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;